exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-form-field {\n  width: 100%;\n  font-size:12px;\n  margin-top:10px;\n}\n.example-full-width {\n  width: 100%;\n}\nh2 {\n  padding-bottom: 10pt;\n}\n.upload-box {\n  padding-top:10px;\n  padding-bottom:10px;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/hq/materials/modify-material.component.css
// module id = ../../../../../src/app/hq/materials/modify-material.component.css
// module chunks = main